import { render, staticRenderFns } from "./ProjectViewContractsView.vue?vue&type=template&id=67d9b380&"
import script from "./ProjectViewContractsView.vue?vue&type=script&lang=js&"
export * from "./ProjectViewContractsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports